module.exports = __webpack_public_path__ + "static/img/manager.1d38dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager.png
// module id = cJ4V
// module chunks = 0